import { TFunction } from 'i18next';

export const getDurStr = (t: TFunction, duration?: number) =>
  t('duration', { m: duration ? Math.round(duration / 60) : 0, context: 'm' });

export const getRemainingDurStr = (t: TFunction, duration?: number) =>
  t('duration.remaining', { dur: getDurStr(t, duration) });

export const getHMSDurationString = (seconds: number) =>
  new Date(seconds * 1000).toUTCString().match(/(\d\d:\d\d:\d\d)/)?.[0];
